module.exports = __webpack_public_path__ + "static/media/plan_chapter_view.a1f21596.png";